import React, { useRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './Sidebar.module.scss';
import { Icon } from '../../Icon';
import { useUIContext } from '../../../context/UIContext';
import useOutsideClick from '../../../hooks/useOutsideClick';

export default function Sidebar(props) {
  const {
    className,
    linksClassName,
    footerClassName,
    height,
    isMobile,
    logo,
    profile,
    links,
    footer,
    mini,
    miniTrigger,
    hideMiniTrigger,
    disableDecoration = false,
    inModal = false,
    ...rest
  } = props;

  const { toggleMobileSidebar } = useUIContext();
  const sidebarRef = useRef(null);

  useOutsideClick(sidebarRef, () => isMobile && toggleMobileSidebar());

  return (
    <div className={cx(styles.sidebar, className, { [styles.mini]: mini })} {...rest} ref={sidebarRef}>
      <div className={styles.innerWrapper} style={{ height: isMobile ? `${height}px` : '100%' }}>
        <div className={cx(styles.content, { [styles.mini]: mini })}>
          {logo && (
            <div className={styles.headerContainer}>
              <div className={cx(styles.logo, { [styles.mini]: mini })}>{logo}</div>
              <div className={styles.closeButton} onClick={toggleMobileSidebar}>
                <Icon src="close" className={styles.closeIcon} />
              </div>
            </div>
          )}
          {profile && <div className={cx(styles.profile)}>{profile}</div>}
          {links && <div className={cx(styles.links, { [styles.mini]: mini }, linksClassName)}>{links}</div>}
        </div>
        <div className={cx(styles.footer, footerClassName)}>{footer}</div>
        {!hideMiniTrigger && miniTrigger}
      </div>
    </div>
  );
}

Sidebar.defaultProps = {};

Sidebar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
